import React, { useEffect, useState } from "react";
import axios from "axios";
import "assets/css/packageDetails.css";
import { Icon, Popup } from "semantic-ui-react";
import ImageSlider from "./imageSlider";
import WhatsAppInquire from "./WhatsAppInquire";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import { PackageEnquiryModal } from "../PackageEnquiryModal";

const useStyles = makeStyles((theme) => ({
  color: {
    color: `${theme.palette.primary.main} !important`,
  },
  borderColor: {
    borderBottom: `4px solid ${theme.palette.primary.main} !important`,
  },
  bgColor: {
    backgroundColor: `${theme.palette.primary.main} !important`,
  },
}));

export default function PackageDetails(props) {
  const classes = useStyles();
  const [p, setP] = useState({});
  const [uniqueCities, setUniqueCities] = useState([]);
  const [defaultImages] = useState([
    "https://q-cf.bstatic.com/images/hotel/max1024x768/222/222790006.jpg",
  ]);

  const [showPackageEnquiryModal, setShowPackageEnquiryModal] = useState(false);

  useEffect(() => {
    axios({
      url: `/api/packages/getPackageById?_id=${props.match.params._id}`,
      method: "GET",
    }).then((r) => {
      if (!r.data.success) {
        toast.error(r.data.errorMessage || "Could not get package details!");
      }
      setP(r.data.result);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (p && p.itinerary) return filterUniqueCities();
  }, [p]); // eslint-disable-line react-hooks/exhaustive-deps

  const filterUniqueCities = () => {
    const cities = [];
    const packageValue = p?.itinerary.map((val) => {
      const matched = cities.find((element) => {
        return element.cityName === val.City.cityName;
      });
      if (!matched) cities.push(val.City);
      return true;
    });
    console.log(packageValue);
    setUniqueCities(cities);
  };

  return (
    <>
      {p && (
        <div className="packageDetailsComponent">
          <div className={`heading ${classes.bgColor}`}>
            <h1 style={{ color: "white" }}>{p.packageName}</h1>
            <span className="headingDays">
              {" "}
              ({p.itinerary && p.itinerary.length - 1} Nights /{" "}
              {p.itinerary && p.itinerary.length} Days)
            </span>
          </div>
          <div className="grid1">
            <div className="childGrid1">
              <ImageSlider imagesArray={p.images ? p.images : defaultImages} />
            </div>
            <div className="childGrid1">
              <div className={`inclusions ${classes.color}`}>
                <h2 className={classes.borderColor}>INCLUSIONS</h2>
                <div>
                  {p.inclusions &&
                    p.inclusions.map((inc, index) => (
                      <Popup
                        key={index}
                        content={inc.details}
                        trigger={
                          <span>
                            <Icon
                              name={inc.semanticIcon}
                              key={index}
                              className={classes.color}
                            />{" "}
                            {inc.name}
                          </span>
                        }
                      />
                    ))}
                </div>
              </div>
              <div className="belowInclusions">
                <div className="belowIncChild">
                  <div className={`title`}>
                    <Icon
                      name="calendar alternate outline"
                      className={classes.color}
                    />
                    Duration
                  </div>
                  <div>
                    <p>
                      {p.itinerary && p.itinerary.length - 1} Nights /{" "}
                      {p.itinerary && p.itinerary.length} Days
                    </p>
                  </div>
                </div>
                <div className="belowIncChild sideBorder">
                  <div className={`title`}>
                    <Icon
                      name="map marker alternate"
                      className={classes.color}
                    />{" "}
                    Destinations Covered
                  </div>
                  <div>
                    <p>
                      {uniqueCities.map((val, i, arr) => (
                        <span key={i}>
                          {val.cityName}
                          {i + 1 !== arr.length && ","}
                        </span>
                      ))}
                    </p>
                  </div>
                </div>
                <div className="belowIncChild">
                  <div className={`title`}>
                    <Icon name="tags" className={classes.color} />
                    Tour Category
                  </div>
                  <div>
                    <p>will add tour category</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <WhatsAppInquire package={p} /> */}

          <div className="text-center mt-4">
            <button
              className="btn btn-success px-5 py-3"
              onClick={() => {
                setShowPackageEnquiryModal(true);
              }}
            >
              Enquire Now
            </button>
          </div>

          <h2 className={`itineraryHeading ${classes.bgColor}`}>
            Day by day Tour Plan
          </h2>

          {p.itinerary &&
            p.itinerary.map((day, index) => {
              return (
                <div className="row container mx-auto shadow my-4 p-1 ">
                  <div className="col-12 text-center">
                    <p className="fs-3 fw-light mb-4">
                      <b>
                        Day {index + 1} - {day.Title}
                      </b>
                    </p>
                  </div>
                  {day.image && day.image.length && (
                    <div className="col-md-4 col-12">
                      <div className="w-100 p-0">
                        <ImageSlider imagesArray={day.image} />
                      </div>
                    </div>
                  )}
                  <div className="col-md-8 col-12 ">
                    <p className="fs-5 fw-normal m-2">
                      City - {day.City.cityName}
                    </p>

                    <div
                      dangerouslySetInnerHTML={{ __html: day.Description }}
                      className="ckEditorDiv  p-2 fw-lighter"
                    />

                    {day["Extra Information"] && (
                      <p>Extra Information: {day["Extra Information"]}</p>
                    )}
                  </div>
                </div>
              );
            })}

          {p.inclusions && p.inclusions.length > 0 && (
            <React.Fragment>
              <h2 className={`itineraryHeading ${classes.bgColor}`}>
                List of Inclusion
              </h2>
              <div className="inclusionsList">
                {p.inclusions.map((inc, index) => (
                  <div className="inclusionsItem" key={index}>
                    <Icon
                      name={inc.semanticIcon}
                      circular
                      className={classes.color}
                    />
                    <b className={classes.color}>{inc.name}</b>{" "}
                    {inc.details && `- ${inc.details}`}
                  </div>
                ))}
              </div>
              {/* <WhatsAppInquire package={p} /> */}
              <div className="text-center my-4">
                <button
                  className="btn btn-success px-5 py-3"
                  onClick={() => {
                    setShowPackageEnquiryModal(true);
                  }}
                >
                  Enquire Now
                </button>
              </div>
            </React.Fragment>
          )}
          <div className="spacer100"></div>
        </div>
      )}

      {showPackageEnquiryModal && (
        <PackageEnquiryModal
          show={showPackageEnquiryModal}
          onClose={() => {
            setShowPackageEnquiryModal(false);
          }}
          packageName={`${p.packageName} (${
            p.itinerary && p.itinerary.length - 1
          } Nights / ${p.itinerary.length} Days)`}
        />
      )}
    </>
  );
}
